import useClipboard from 'vue-clipboard3'
import { getDeviceInfo } from '@/utils'

export const useClipboard1 = () => {
    const { toClipboard } = useClipboard()

    const cliboarded = async (text) => {
        if (getDeviceInfo().os === 'iOS' && navigator.clipboard) {
            await navigator.clipboard.writeText(text)
        } else {
            await toClipboard(text)
        }
    }

    return {
        toClipboard: cliboarded,
    }
}
